var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3168 12.7622C38.4664 8.42313 35.2089 4.83342 31.0694 2.57156C26.9299 0.309699 22.1493 -0.492575 17.4982 0.294023C12.8471 1.08062 8.59624 3.41028 5.43069 6.90757C2.26514 10.4049 0.36927 14.8661 0.0485836 19.5724C-0.272103 24.2786 1.00108 28.9558 3.66295 32.8502C6.32483 36.7446 10.2204 39.6293 14.7218 41.0396C19.2232 42.4498 24.0684 42.3034 28.4765 40.624C32.8846 38.9446 36.5989 35.8299 39.0208 31.782L38.0108 31.1777C35.7247 34.9988 32.2185 37.9389 28.0575 39.5242C23.8964 41.1095 19.3228 41.2477 15.0736 39.9165C10.8245 38.5853 7.14727 35.8622 4.63457 32.1861C2.12188 28.5099 0.920049 24.0949 1.22276 19.6524C1.52548 15.2099 3.3151 10.9986 6.30324 7.69735C9.29138 4.39606 13.304 2.19696 17.6945 1.45445C22.0849 0.711933 26.5975 1.46925 30.5051 3.60435C34.4126 5.73945 37.4875 9.12797 39.2342 13.2239L40.3168 12.7622Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.4f37917e582613ce9f80a843a88f31ec.svg";
export { ForwardRef as ReactComponent };